export const EServerSentEventsChannel = {
  I9_ONBOARDING_INFO_UPDATED: "i9-onboarding-info-updated",
  CHECK_PREVIEW_UPDATED: "check-preview-updated",
} as const;

export type EServerSentEventsChannel =
  (typeof EServerSentEventsChannel)[keyof typeof EServerSentEventsChannel];

export const EServerSentEvent = {
  I9_ADMIN_REVIEW: "i9.admin.review",
  PERSONA_IDV_DECISION: "persona.idv.decision",
  VERIFF_IDV_DECISION: "veriff.idv.decision",
  CHECK_PREVIEW_COMPLETED: "check.preview.completed",
  CHECK_PREVIEW_FAILED: "check.preview.failed",
  CHECK_PREVIEW_PROGRESS: "check.preview.progress",
  CHECK_PREVIEW_STARTED: "check.preview.started",
} as const;

export type EServerSentEvent =
  (typeof EServerSentEvent)[keyof typeof EServerSentEvent];
